import useSWR from 'swr';
import { useLocalStorage } from 'usehooks-ts';

import { apiFetcher } from '../utils/fetchers';
import { ManualScoring } from '../types/manual-scoring';
import { KendoGridResult } from '../types/KendoGridResult';

export const useGetManualScoringAnswers = (gameCode?: string) => {
  const [taskScorings, setTaskScorings] = useLocalStorage<ManualScoring[]>(
    `task-scorings-${gameCode}`,
    []
  );

  const { error, isLoading } = useSWR<KendoGridResult<ManualScoring>>(
    gameCode ? `games/${gameCode}/players/answer` : null,
    apiFetcher,
    {
      onSuccess: (data) => {
        const sorted = data.data.sort(
          (a, b) =>
            new Date(b.SubmittedDateUtc as string).valueOf() -
            new Date(a.SubmittedDateUtc as string).valueOf()
        );

        const result = sorted.reduce((map, item) => {
          const key = `${item.playerCode}-${item.taskId}-${item.formId}`;
          if (!map.has(key)) map.set(key, item);
          return map;
        }, new Map<string, ManualScoring>());

        setTaskScorings([...result.values()]);
      }
    }
  );

  return { data: taskScorings, error, isLoading };
};
